import { useRef, type ReactNode } from "react";
import { gsap, MOTION_OK, useGSAP } from "../../lib/gsap";

interface RevealProps {
  children: ReactNode;
  className?: string;
  /** Deslocamento vertical inicial (px). */
  y?: number;
  delay?: number;
  /** Com stagger, anima os filhos marcados com `data-reveal` em sequência. */
  stagger?: number;
  /** Refaz a animação quando estes valores mudam (ex.: dados que chegaram da API). */
  deps?: unknown[];
}

/** Revela o conteúdo ao entrar na tela (GSAP + ScrollTrigger, uma única vez). */
export const Reveal = ({ children, className, y = 40, delay = 0, stagger, deps = [] }: RevealProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useGSAP(
    () => {
      const el = ref.current;
      if (!el) return;
      const mm = gsap.matchMedia();
      mm.add(MOTION_OK, () => {
        const targets = stagger ? el.querySelectorAll("[data-reveal]") : [el];
        if (targets.length === 0) return;
        // Só opacity (não autoAlpha): visibility:hidden tiraria o conteúdo da árvore de acessibilidade.
        gsap.from(targets, {
          y,
          opacity: 0,
          duration: 0.9,
          delay,
          stagger,
          ease: "power3.out",
          scrollTrigger: { trigger: el, start: "top 85%", once: true },
        });
      });
    },
    { scope: ref, dependencies: deps, revertOnUpdate: true },
  );

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
};
